<template>
	<el-drawer  custom-class="ads_create" title="创建广告" size="60%" :modal="modal" :visible.sync="AdModalDrawer" direction="rtl">
	    <el-row style="position:relative;height:100%;">		 
		 <div style="position:absolute;left:20px;top:0;right:0;bottom:0;overflow-y:auto;padding-right:2%;overflow-x:hidden;">
			<el-container>
			  <el-aside width="40%">
			    <h3>广告组列表</h3>
				 <el-input placeholder="输入关键字进行过滤" clearable style="margin-bottom:10px;"  size="small" v-model="filterText"></el-input>
				<el-tree
				  :props="defaultProps"
				   :data="CampaignListData"
				   :filter-node-method="filterNode"
				   @node-click="getCurrentNode"
				   ref="tree"
				  accordion>
				</el-tree>
			  </el-aside>
			  <el-container>
				  <el-main>
					<h3><i class="fa fa-circle" style="color:#ff6f5e;font-size:10px;"></i> {{campaign_name}}</h3>
                    <el-tabs v-model="activeName">
						
						<el-tab-pane label="广告基础属性" name="second">
						  	<el-row style="margin-bottom:10px;padding:15px;">					  
					   <el-col :span="24">
					      <el-form ref="form" :model="AdsForm"  label-width="80px">
														
							<el-form-item label="下载方式">
								<el-radio-group size="small" v-model="AdsForm.download_type">
								  <el-radio-button label="DOWNLOAD_URL">下载链接</el-radio-button>
								  <el-radio-button label="EXTERNAL_URL">落地页</el-radio-button>								  
								</el-radio-group>
							  </el-form-item>
							  <el-form-item v-if="AdsForm.download_type=='EXTERNAL_URL'" label="来源">
								<el-input size="small" v-model="CreateForm.source"></el-input>
							  </el-form-item>
							  <el-form-item v-if="AdsForm.download_type=='EXTERNAL_URL'" label="链接地址">
                                 <el-input  size="small" v-model="AdsForm.external_url"></el-input>
							  </el-form-item>							  
							  <el-form-item v-if="AdsForm.download_type=='DOWNLOAD_URL'" label="下载地址">
                                 <el-input  size="small"   v-model="AdsForm.download_url">
								  <a slot="append" :href="AdsForm.download_url" target="__blank" style="font-size:12px;">访问</a>
								 </el-input>
							  </el-form-item>
							  <el-form-item v-if="AdsForm.download_type=='DOWNLOAD_URL'" label="应用包名">
                                 <el-input size="small"  v-model="AdsForm.package"></el-input>
							  </el-form-item>
							  <el-form-item v-if="AdsForm.download_type=='DOWNLOAD_URL'" label="应用名">
                                 <el-input size="small" v-model="CreateForm.app_name"></el-input>
							  </el-form-item>
							  <el-form-item label="转化ID">                 
								 <el-autocomplete popper-class="my-autocomplete" size="small" v-model="AdsForm.convert_id" :fetch-suggestions="querySearch" placeholder="请输入转化ID" @select="handleSelect">
								  <template slot-scope="{ item }">
									<div class="name">{{ item.id }}</div>
									<span class="addr">{{ item.name }}</span>
								  </template>
								 </el-autocomplete>
							</el-form-item>							 
							  <el-form-item  label="定向人群">
								<el-select size="small" v-model="AdsForm.retargeting_tags_include" class="custom_audience" multiple placeholder="请选择">
								  <el-option v-for="item in custom_audience"  :key="item.custom_audience_id" :label="item.name" :value="item.custom_audience_id"></el-option>
								</el-select>
							  </el-form-item>
							  <el-form-item  label="排除人群">
								<el-select size="small" v-model="AdsForm.retargeting_tags_exclude" class="custom_audience" multiple placeholder="请选择">
								  <el-option v-for="item in custom_audience" :label="item.name" :key="item.custom_audience_id" :value="item.custom_audience_id"></el-option>
								</el-select>
							  </el-form-item>
							  <el-form-item  label="兴趣定向">
								<el-radio-group size="small" v-model="AdsForm.ad_tag">
								  <el-radio-button label="">不限</el-radio-button>
								  <el-radio-button label="0">系统推荐</el-radio-button>						  
								</el-radio-group>
							  </el-form-item>
							  <el-form-item  label="网络">	
								<el-checkbox-group size="small" v-model="AdsForm.ac">								 
								  <el-checkbox-button label="WIFI">WIFI</el-checkbox-button>
                                  <el-checkbox-button label="2G">2G</el-checkbox-button>
                                  <el-checkbox-button label="3G">3G</el-checkbox-button>
                                  <el-checkbox-button label="4G">4G</el-checkbox-button>								  
								</el-checkbox-group>
							  </el-form-item>							 
							  <el-form-item  label="最低系统版本" label-width="120px">
								<el-select size="small" v-model="AdsForm.version">
									<el-option v-for="item in versionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
								  </el-select>
                             </el-form-item>                            
							 <el-form-item label="出价方式">
								<el-radio-group size="small" v-model="AdsForm.smart_bid_type">
								  <el-radio label="SMART_BID_CUSTOM">手动</el-radio>
								  <el-radio label="SMART_BID_CONSERVATIVE">自动</el-radio>								  
								</el-radio-group>
							  </el-form-item>
							  <el-form-item v-show="AdsForm.smart_bid_type=='SMART_BID_CUSTOM'" label="目标出价">
                                 <el-input size="small" style="width:60%;" v-model="AdsForm.cpa_bid">
								  <template slot="append">元</template>
								 </el-input>
							  </el-form-item>
							  <el-form-item label="投放方式">
								<el-radio-group size="small" v-model="AdsForm.flow_control_mode">
								  <el-radio-button label="FLOW_CONTROL_MODE_FAST">优先跑量</el-radio-button>
								  <el-radio-button label="FLOW_CONTROL_MODE_BALANCE">均衡投放</el-radio-button>
                                  <el-radio-button label="FLOW_CONTROL_MODE_SMOOTH">优先低成本</el-radio-button>								  
								</el-radio-group>
							  </el-form-item>
							  <el-form-item label="预算">
								<el-input size="small"  placeholder="设置预算金额" v-model="AdsForm.budget" class="input-with-select">
									<el-select style="width:100px;" v-model="AdsForm.budget_mode" slot="prepend" placeholder="请选择">
									  <el-option label="日预算" value="BUDGET_MODE_DAY"></el-option>
									  <el-option label="总预算" value="BUDGET_MODE_TOTAL"></el-option>
									</el-select>									
								  </el-input>
							  </el-form-item>
							  <el-form-item label="投放时间">
                                 <el-radio-group size="small" v-model="AdsForm.schedule_type">
								  <el-radio-button label="SCHEDULE_FROM_NOW">从今天起长期投放</el-radio-button>
								  <el-radio-button label="SCHEDULE_START_END">设置开始和结束时间</el-radio-button>					  
								</el-radio-group>
							  </el-form-item>
							  <el-form-item v-show="AdsForm.schedule_type=='SCHEDULE_START_END'">
							     <el-date-picker value-format="yyyy-MM-dd HH:mm" size="small" style="width:44%;" v-model="AdsForm.start_time" type="date" placeholder="开始日期"></el-date-picker>-
                                 <el-date-picker value-format="yyyy-MM-dd HH:mm" size="small" style="width:44%;" v-model="AdsForm.end_time" type="date" placeholder="结束日期"></el-date-picker>								 
							  </el-form-item>
							  <!--<el-form-item label="投放时段">
							     <el-input type="textarea"  v-model="AdsForm.schedule_time"></el-input>					
							  </el-form-item>-->						  
						   </el-form>
						</el-col>
                    </el-row>
						</el-tab-pane>
						<el-tab-pane label="定向维度" name="four">
						  <el-row style="margin-bottom:10px;padding:15px;">
						     <el-col :span="24">
							    <el-form ref="form" label-width="80px">					
									  <el-form-item  label="媒体版位">
										  <el-tag size="mini" @close="closeMedia(index)" :key="index" v-for="(m,index) in MediaFormList" closable type="danger">{{'版位'+(index+1)}} <i  @click="EditMediadialogForm(index,m)" class="el-icon-edit"></i></el-tag>
										  <el-button size="mini" @click="addMediadialogForm">+添加</el-button>
									  </el-form-item>
									   <el-form-item label="用户性别">
									      <el-checkbox-group v-model="SexFormList" size="mini">
											<el-checkbox-button label="NONE">不限</el-checkbox-button>
											<el-checkbox-button label="GENDER_MALE">男</el-checkbox-button>
											<el-checkbox-button label="GENDER_FEMALE">女</el-checkbox-button>
										  </el-checkbox-group>
									  </el-form-item>
									   <el-form-item  label="用户年龄">
									       <el-tag size="mini" @close="closeAge(index)" :key="index" v-for="(a,index) in AgeFormList" closable type="warning">{{'年龄段'+(index+1)}} <i  @click="EditAgedialogForm(index,a)" class="el-icon-edit"></i></el-tag>
										   <el-button size="mini" @click="addAgedialogForm">+添加</el-button>							  
									  </el-form-item>
								</el-form>
							 </el-col>
						  </el-row>
						     <!-- 媒体版位 -->								
								<el-dialog title="编辑/创建" width="50%" :append-to-body="append_body" :visible.sync="MediadialogFormVisible">
								  <el-form :model="MediaForm">
									 <el-form-item label="投放范围">
										<el-radio-group @change="handleInventory" size="small" v-model="MediaForm.delivery_range">
										  <el-radio label="DEFAULT">默认</el-radio>
										  <el-radio label="UNION">穿山甲</el-radio>								  
										</el-radio-group>
									  </el-form-item>
									 <el-form-item v-if="MediaForm.delivery_range=='DEFAULT'" label="媒体版位">
										<el-radio-group  @change="handleInventory" size="small" v-model="MediaForm.inventory">
										  <el-radio-button label="smart_inventory">优选广告位</el-radio-button>
										  <el-radio-button label="inventory_type">按媒体指定位置</el-radio-button>、
										  <el-radio-button label="scene_inventory">按场景指定位置</el-radio-button>						  
										</el-radio-group>
									  </el-form-item>
									  <el-form-item v-if="(MediaForm.inventory=='scene_inventory')&&(MediaForm.delivery_range=='DEFAULT')">										
										 <el-radio-group  v-model="MediaForm.scene_inventory">
										   <el-radio label="VIDEO_SCENE">沉浸式竖版视频场景广告位</el-radio>
										   <el-radio label="FEED_SCENE">信息流场景广告位</el-radio>
										   <el-radio label="TAIL_SCENE">视频后贴和尾帧场景广告位</el-radio>
										  </el-radio-group>
									  </el-form-item>
									   <el-form-item v-if="(MediaForm.inventory=='inventory_type')&&(MediaForm.delivery_range=='DEFAULT')">										
										 <el-checkbox-group v-model="MediaForm.inventory_type">
										   <el-checkbox label="INVENTORY_FEED">头条系</el-checkbox>
										   <el-checkbox label="INVENTORY_VIDEO_FEED">西瓜信息流</el-checkbox>
										   <el-checkbox label="INVENTORY_HOTSOON_FEED">火山信息流</el-checkbox>
										   <el-checkbox label="INVENTORY_AWEME_FEED">抖音信息流</el-checkbox>
										   <el-checkbox disabled label="INVENTORY_UNION_SLOT">穿山甲</el-checkbox>
										  </el-checkbox-group>
									  </el-form-item>
									  <el-form-item v-if="MediaForm.delivery_range=='UNION'" label="投放形式">
										<el-radio-group size="small" v-model="MediaForm.union_video_type">
										  <el-radio-button label="REWARDED_VIDEO">激励视频</el-radio-button>
										  <el-radio-button label="ORIGINAL_VIDEO">原生</el-radio-button>								  
										</el-radio-group>
									  </el-form-item>
									  <el-form-item v-if="MediaForm.delivery_range=='UNION'" label="设备类型">
										 <el-checkbox-group style="float:left;" v-model="MediaForm.device_type">
											<el-checkbox label="MOBILE">智能手机</el-checkbox>
											<el-checkbox label="PAD">平板</el-checkbox>											
										  </el-checkbox-group>
										  <span style="font-size:10px;margin-left:10px;"><label style="color:red;">(*)</label> 注意:设备类型目前仅投放范围为穿山甲且账户有白名单权限</span>
									  </el-form-item>
									  <el-form-item label="试玩素材" v-if="MediaForm.delivery_range=='UNION'">
										<el-switch v-model="playableSwitch"></el-switch>																		 
									  </el-form-item>
									  <el-form-item label="试玩素材地址" v-if="playableSwitch && MediaForm.delivery_range=='UNION'">
                                        <el-autocomplete style="width:60%;" class="inline-input" size="small" v-model="MediaForm.playable_url" @select="handleSelectPlay" :fetch-suggestions="querySearchAsync" placeholder="请输入试玩链接地址">
										 <template slot-scope="{ item }">
											<div class="name" style="color:#537ec5;">{{ item.playable_name }}</div>
											<span class="addr">{{ item.playable_url }}</span>
										  </template>
										</el-autocomplete>										
									  </el-form-item>
								  </el-form>
								  <div slot="footer" class="dialog-footer">
									<el-button @click="MediadialogFormVisible = false">取 消</el-button>
									<el-button type="danger" :disabled="MediaFormDisabled" @click="RepeatMediaFormSubmit">新 建</el-button>
									<el-button type="primary" @click="MediaFormSubmit">保 存</el-button>
								  </div>
								</el-dialog>
							<!-- 用户年龄 -->								
								<el-dialog title="编辑/创建" :append-to-body="append_body" :visible.sync="AgedialogFormVisible">
								  <el-form>									 									 
									  <el-form-item>
										 <el-checkbox-group v-model="AgeForm.age" size="mini">
											  <el-checkbox label="AGE_BELOW_18"><18</el-checkbox>
											  <el-checkbox label="AGE_BETWEEN_18_23">18-23</el-checkbox>
											  <el-checkbox label="AGE_BETWEEN_24_30">24-30</el-checkbox>
											  <el-checkbox label="AGE_BETWEEN_31_40">31-40</el-checkbox>
											  <el-checkbox label="AGE_BETWEEN_41_49">41-49</el-checkbox>
											  <el-checkbox label="AGE_ABOVE_50">>=50</el-checkbox>
											</el-checkbox-group>
									  </el-form-item>									  
								  </el-form>
								  <div slot="footer" class="dialog-footer">
									<el-button @click="AgedialogFormVisible = false">取 消</el-button>
									<el-button type="primary" @click="AgeFormSubmit">保 存</el-button>
								  </div>
								</el-dialog>
						</el-tab-pane>
						<el-tab-pane label="创意维度" name="three">
						  <el-row style="margin-bottom:10px;padding:15px;">
						   <el-col :span="24">
						       <div class="demo-image__preview">
								  <div style="font-size:14px;font-weight:bold;padding:10px 0px;"><i style="color:#baabda;" class="fa fa-dot-circle-o"></i> 上传素材</div>
								     <div class="el-image" v-for="item in selectVideoMaterial" style="width:80px; height: 80px;position:relative;margin-right:10px;">
									     <img :src="item.image_obj.url" class="el-image__inner">
										<span class="el-upload-list__item-actions">
										  <span class="el-upload-list__item-preview" @click="editVideoMaterial(item)"><i class="el-icon-edit"></i></span>
										  <span class="el-upload-list__item-preview" @click="deleteSelVideoMaterial(item)"><i class="el-icon-delete"></i></span>
										</span>
									 </div>
									  <div class="add_avatar" @click="openMaterialDialog">
									    <i class="el-icon-plus avatar-uploader-icon"></i>
									 </div>
									 <el-dialog
										  title="广告素材上传"
										  :visible.sync="materialDialogVisible"
										  :append-to-body="append_body"
										  width="50%">
										  <div class="materialContain">
										    <el-form   class="demo-dynamic">
											<el-form-item label="素材类型">
												<el-radio-group v-model="image_mode" size="small">
												  <el-radio-button label="CREATIVE_IMAGE_MODE_VIDEO">横版视频</el-radio-button>
												  <el-radio-button label="CREATIVE_IMAGE_MODE_VIDEO_VERTICAL">竖版视频</el-radio-button>
												  <el-radio-button disabled label="CREATIVE_IMAGE_MODE_SMALL">小图</el-radio-button>
												  <el-radio-button disabled label="CREATIVE_IMAGE_MODE_LARGE">大图</el-radio-button>
												  <el-radio-button disabled label="CREATIVE_IMAGE_MODE_GROUP">组图</el-radio-button>
												</el-radio-group>
											</el-form-item>
											<el-form-item label="素材内容">											
												<el-row>
												   <div class="add_avatar" style="margin-right:10px;" v-for="item in selectVideo">
												     <img :src="item.poster_url" class="avatar-uploader-icon">
													 <span class="el-upload-list__item-actions">
													    <el-tooltip class="item" effect="dark" content="选择封面图" placement="top">
														   <span class="el-upload-list__item-preview" @click="video_cover(item)"><i class="el-icon-picture-outline"></i></span>
														</el-tooltip>									  
													   <span class="el-upload-list__item-preview" @click="deleteSelVideo(item)"><i class="el-icon-delete"></i></span>
													  </span>
												   </div>
												  <div class="add_avatar" @click="libDialogOpen()">
													 <i class="el-icon-plus avatar-uploader-icon"></i>
												   </div>												   
												</el-row>
												<LibPanel ref="Lib" @func="getSelectVideo"></LibPanel>
											</el-form-item>
											
                                            <el-form-item>											
												<span>封面选取<label style="color:red;">(*必选)</label></span>
												<el-row>
												   <div v-loading="thumbLoading">
												   <el-radio-group v-model="selectThumb" @change="handleThumb">
													  <div class="add_avatar thumb_list" style="border:none;" v-for="i in thumb_List">
														 <img :src="i.url" class="el-image__inner">
														 <el-radio class="thumb_select" :label="i">&nbsp;</el-radio>
													   </div>
												  </el-radio-group>
												  </div>
												</el-row>
											</el-form-item>											
											</el-form>									   
										  </div>
										  <span slot="footer" class="dialog-footer">
											<el-button @click="materialDialogVisible = false">取 消</el-button>
											<el-button type="primary" @click="materialConfirm">确 定</el-button>
										  </span>
										</el-dialog>
								</div>
								<div style="font-size:14px;font-weight:bold;padding:10px 0px;"><i style="color:#baabda;" class="fa fa-magic"></i> 创意标题</div>
								<el-form   class="demo-dynamic">								  
								  <el-form-item>
									 <el-button size="mini" type="success" plain @click="addTitle">+添加标题</el-button>
								  </el-form-item>
								  <el-form-item v-for="(item, index) in CreateForm.title_list" :label="'标题' + (index+1)" :key="index">
									<el-input style="width:60%;margin-right:10px;" size="mini" v-model="item.value" ></el-input><el-button  size="mini" icon="el-icon-delete" type="danger" @click.prevent="removeDomain(item)">删除</el-button>
								  </el-form-item>
								  <div style="font-size:14px;font-weight:bold;padding:10px 0px;"><i style="color:#baabda;" class="fa fa-tags"></i> 其他属性</div>
								  <el-form-item label="副标题">
									  <el-input size="mini" style="width:60%;" v-model="CreateForm.advanced_creative_title" />
								  </el-form-item>
								  <el-form-item label="创意分类">
									  <el-select filterable v-model="CreateForm.third_industry_id" size="mini" placeholder="请选择">
										<el-option v-for="item in industrylist" :key="item.value" :label="item.label" :value="item.value"></el-option>
									  </el-select>
								  </el-form-item>
								   <el-form-item label="展现方式">										 
										  <el-checkbox-group v-model="CreateForm.creative_display_mode">
											<el-checkbox label="CREATIVE_DISPLAY_MODE_CTR">优选</el-checkbox>
											<el-checkbox label="CREATIVE_DISPLAY_MODE_RANDOM">轮播</el-checkbox>
										  </el-checkbox-group>
									  </el-form-item>
								    <el-form-item  label="创意标签">
                                     <el-input size="small"  placeholder="最多20个标签，每个不超过10个字，请用#分割" v-model="CreateForm.ad_keywords"></el-input>
							       </el-form-item>	
								</el-form>
						   </el-col>
						   </el-row>
						</el-tab-pane>
					 </el-tabs>									
				  </el-main>
				  <el-footer>
				   <el-button size="small">取消</el-button>
				   <el-button size="small" @click="reset" type="warning">清除数据</el-button>
				   <el-button type="primary" @click="CreateAds" v-loading="submitLoading" size="small">立即创建</el-button>	   
				  </el-footer>
			  </el-container>
			</el-container>
		 </div>
	   </el-row>
	</el-drawer>
</template>

<script>
	import LibPanel from './lib.vue'
	import { getIndustryList,getDefaultDataList,getVideoThumbList,CreateAdsPost } from '../../../../api/api';
	export default {
		components: {LibPanel},
		props:{		  
		  CampaignList:{
		    type: Array,
			default:null
		  }
		},
		data() {
			return {
				versionList:[],				
				dialogFormVisible:false,
				MediadialogFormVisible:false,
				AdModalDrawer:false,
				materialDialogVisible:false,
				thumbLoading:false,
				campaign_name:'',
				submitLoading:false,
				playableSwitch:false,
				checked:false,
				selectVideo:[],
				disabled:true,
				selectThumb:{},
				selectThumbList:[],
				selectVideoMaterial:[],
				thumb_List:[],
				campaign_id:'',
				video_id:'',
				image_mode:'',
				radio:'',
				custom_audience:[],
				materialType:'video',
				AgedialogFormVisible:false,
				CreateForm:{
				  creative_display_mode:[],
				  title_list:[]
				},
				MediaFormIndex:-1,
				AgeFormIndex:-1,
				AdsForm:{
				 ac:[],
				 budget_mode:'BUDGET_MODE_DAY'
				},
				MediaFormDisabled:false,
				MediaFormList:[],
				convert_list:[],
				playable_list:[],
				AgeFormList:[],
				SexFormList:[],
				checkList:[],
				MediaForm:{
				  device_type:[],
				  inventory_type:[],
				},
				AgeForm:{
				  age:[]
				},
				defaultProps: {
				  label: 'name'
				},
				append_body:true,			
				filterText:'',
				value:'',
				industrylist:[],				
				activeName:'second',
				modal:false,
				Treedata: []
			}
		},
		 watch: {
		  filterText(val) {
			this.$refs.tree.filter(val);
		  }
		},
		computed:{
		 CampaignListData(){
		     const camList=this.CampaignList.map(item => ({
						id: item.id,  
						name: item.name
					})
				);
				if( camList.length>0 )
				{				  
				  this.campaign_name =camList[0].name
				  this.campaign_id =camList[0].id
				}
				return camList
		   },		  
		  advertiser_id(){
		     return this.$store.getters.getAdvertiserId
		   }
		},
		methods: {
		  getCurrentNode(row,node,m) {
             this.campaign_name = row.name
			 this.campaign_id = row.id
		  },
		  reset(){
			this.selectVideoMaterial =[]
			this.MediaFormList = []
			this.AgeFormList = []
			this.SexFormList = []
			this.checkList =[]
			this.MediaForm={ device_type:[],inventory_type:[]}
			this.AgeForm ={age:[]}
			this.AdsForm ={ac:[],budget_mode:'BUDGET_MODE_DAY'}
			this.CreateForm ={creative_display_mode:[],title_list:[]}
			this.$message.success('清除成功!');
		  },
		  filterNode(value, data) {
			if (!value) return true;
			return data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
		  },
		  querySearch(queryString, cb) {
			var restaurants = this.convert_list;
			var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
			cb(results);
		  },
		   querySearchAsync(queryString, cb) {
           var restaurants = this.playable_list;
           //var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants; 
           cb(restaurants);
		  },
		  handleSelectPlay(item){
		   this.MediaForm.playable_url = item.playable_url
		  },
		  createFilter(queryString) {
			return (restaurant) => {
			  //return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
			  return true
			};
		  },
		  unique(arr) {
		   var obj = {};
		   return arr.reduce(function(item, next) { 
		     obj[next.id]?'':obj[next.id] = true && item.push(next);
			   return item;
			}, []);
		 },
		  getSelectVideo(data){
		   this.selectVideo =  this.unique(this.selectVideo.concat(data));
		  },
		  deleteSelVideo(item){
		   let index=this.selectVideo.findIndex(function (ele) {
			   return ele.id == item.id
			})
			if(index > -1)this.selectVideo.splice(index,1);
			if( this.video_id==item.id )
			{
			  this.thumb_List = []
			}			
		  },
		  deleteSelVideoMaterial(item){
		   let index=this.selectVideoMaterial.findIndex(function (ele) {
			   return ele.video_id == item.video_id
			})
			if(index > -1)this.selectVideoMaterial.splice(index,1);
		  },
		  video_cover(item){
		   
			let params ={
			   advertiser_id:this.advertiser_id,
			   video_id:item.id,
			   type:1
			}
			this.video_id = item.id
			 let index=this.selectThumbList.findIndex(function (ele) {
			   return ele.video_id == item.id
			})
			if( index >-1 ){			   
			   this.thumb_List =this.selectThumbList[index].thumb_list
			   this.selectThumb =this.selectThumbList[index].image_obj
			   return false;
			}
			this.thumbLoading = true			
			getVideoThumbList(params).then((res) => {
					this.thumbLoading = false				
					this.thumb_List = res.data					
			});
		  },
		  handleSelect(item){
		    this.AdsForm.convert_id = item.id.toString(); 
		  },
		  CreateAds(){
		    let params = {
			   advertiser_id:this.advertiser_id,
			   campaign_id:this.campaign_id,
			   adsdimension:{ MediaFormList:this.MediaFormList,SexFormList:this.SexFormList,AgeFormList:this.AgeFormList,selectVideoMaterial:this.selectVideoMaterial},
			   adsform:this.AdsForm,
			   createform:this.CreateForm			   
			}
			this.submitLoading = true
			CreateAdsPost(params).then((res) => {
					this.submitLoading = false
					if( res.code==200 )
					{
					  this.$notify({
						  title: '创建成功',
						  type: 'success'
						});
					}else{
					   this.$notify.error({
						  title: '错误',
						  message:res.message
						});
					}
				});
		  },
		  handleThumb(item){
		   let video_id = this.video_id
		   let vindex=this.selectVideo.findIndex(function (v) {
			   return v.id == video_id
			})
		   let obj = {
		       video_id:video_id,
			   image_id:item.id,
			   video_list:[this.selectVideo[vindex]],
			   image_obj:item,
			   thumb_list:this.thumb_List
		   }
		   let index=this.selectThumbList.findIndex(function (ele) {
			   return ele.video_id == video_id
			})
			if(index > -1){                
				this.selectThumbList[index] = obj
			}else{
			 this.selectThumbList.push(obj)
			}
		  },
		  editVideoMaterial(item){
		    this.selectThumbList = [item]
			this.thumb_List = item.thumb_list
			this.selectVideo = item.video_list
			this.image_mode = item.image_mode
			this.selectThumb = item.image_obj
			this.materialDialogVisible = true		
		  },
		  openMaterialDialog(){
		     this.thumb_List =[]
			 this.selectThumbList = []
			 this.selectVideo =[]
			 this.selectThumb ={}
			 this.image_mode =""
			 this.materialDialogVisible = true
		  },
		  uniqueVideoMaterial(arr) {
		   var obj = {};
		   return arr.reduce(function(item, next) { 
		     obj[next.video_id]?'':obj[next.video_id] = true && item.push(next);
			   return item;
			}, []);
		 },
		  materialConfirm(){
		   if( !this.image_mode )
		   {
		      this.$message.error('请选择素材类型!');
			  return false;
		   }
		   if( this.selectThumbList.length<1 )
		   {
		      this.$message.error('请选择素材内容!');
			  return false;
		   }
		   if( this.selectThumbList.length!==this.selectVideo.length )
		   {
		      this.$message.error('请选择封面图!');
			  return false;
		   }
		   let image_mode = this.image_mode
           let result = this.selectThumbList.map(item => {
				item.image_mode = image_mode
				return item
			})
		   this.selectVideoMaterial = this.uniqueVideoMaterial(this.selectVideoMaterial.concat(result))		  	  
		   this.materialDialogVisible = false	   
		  },
		  mainDrawer(){
		    this.AdModalDrawer = true
			this.getindustry()
			this.getDefaultData()		
		  },
		  libDialogOpen(){
		   this.$refs['Lib'].openModel()
		  },
		  getindustry(){
		    let param = {
			   advertiser_id:this.advertiser_id,
			   type:1
			}
			 getIndustryList(param).then((res) => {
					this.industrylist = res.data
				});
		  },
		  getDefaultData(){
		     let param = {
			   advertiser_id:this.advertiser_id,
			   type:1
			}
			 getDefaultDataList(param).then((res) => {
					this.versionList = res.data.versionList
					this.AdsForm = res.data.AdsForm
					this.CreateForm.app_name = res.data.app_name
					this.convert_list = res.data.convert_list
					this.custom_audience = res.data.audience
					this.playable_list = res.data.playable_list
				});
		  },
		  handleInventory(val){
			this.$set(this.MediaForm,'device_type',[])
			this.$set(this.MediaForm,'inventory_type',[])
			this.$set(this.MediaForm,'scene_inventory','')
			this.$set(this.MediaForm,'playable_url','')
		  },
		  closeMedia(index){
		    this.MediaFormList.splice(index, 1);
		  },
		   closeAge(index){
		    this.AgeFormList.splice(index, 1);
		  },
		  MediaFormSubmit(){
		    if( !this.MediaForm.delivery_range )
			{
			  this.$message.error('请选择投放范围');return false
			}
			if( this.MediaFormIndex==-1 )
			{
               this.MediaFormList.push(this.MediaForm)			
			}else{
			  this.MediaFormList[this.MediaFormIndex] = this.MediaForm
			}			
			this.MediadialogFormVisible = false
		  },
		  RepeatMediaFormSubmit(){
		    this.MediaFormList.push(this.MediaForm)
			//this.MediadialogFormVisible = false
		  },
		  EditMediadialogForm(index,m){
		    this.MediaFormIndex = index
			this.MediaForm = m
			this.MediaFormDisabled = false
			this.MediadialogFormVisible = true
		  },
		  addMediadialogForm()
		  {
		    this.MediaFormIndex = -1
			this.MediaForm={ device_type:[],inventory_type:[]}
			this.MediaFormDisabled = true
			this.MediadialogFormVisible = true
		  },
		  EditAgedialogForm(index,m){
		    this.AgeFormIndex = index
			this.AgeForm = m
			this.AgedialogFormVisible = true
		  },
		  addAgedialogForm()
		  {
		    this.AgeFormIndex = -1
			this.AgeForm={ age:[]}
			this.AgedialogFormVisible = true
		  },
		  AgeFormSubmit()
		  {
		    if( this.AgeForm.age.length<1 )
			{
			  this.$message.error('请选择用户年龄段');return false
			}
			if( this.AgeFormIndex==-1 )
			{
               this.AgeFormList.push(this.AgeForm)			
			}else{
			  this.AgeFormList[this.AgeFormIndex] = this.AgeForm
			}			
			this.AgedialogFormVisible = false
		  },
		  addTitle() {
				this.CreateForm.title_list.push({
				  value: '',
				  key: Date.now()
				});
			},
		  removeDomain(item)
		  {
			
			var index = this.CreateForm.title_list.indexOf(item)
			if (index !== -1) {
			  this.CreateForm.title_list.splice(index, 1)
			}
		  }
		},
		
		mounted() {
						
		}
	}

</script>
<style  lang="scss">
  .thumb_list{position:relative;margin-right:10px;margin-top:10px;}
  .add_avatar img{width:100%;height:100%;}
  .add_avatar .thumb_select{position:absolute;top:0px;left:0px;line-height:0px;}
  .materialContain .list{
   margin-top:10px;
   height:auto;
  }
  .add_avatar .el-radio__inner{border: 1px solid red;}
  .materialContain .show_img{float:left;margin-left:10px;margin-bottom:10px;}
  .show_img img{width:80px;height:80px;}
  .materialContain .demo-fit{padding:15px;}
  .my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>


// WEBPACK FOOTER //
// drawer.vue?79a84474